var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("basic-container", [
    _c(
      "div",
      { staticClass: "search" },
      [
        _c(
          "el-form",
          {
            ref: "routeQueryForm",
            attrs: { model: _vm.query, inline: true, size: "mini" },
          },
          [
            _c(
              "el-form-item",
              { attrs: { label: "订单号" } },
              [
                _c("el-input", {
                  attrs: { placeholder: "请输入订单号", clearable: "" },
                  nativeOn: {
                    keydown: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      $event.preventDefault()
                      return _vm.querySearch.apply(null, arguments)
                    },
                  },
                  model: {
                    value: _vm.query.orderNo,
                    callback: function ($$v) {
                      _vm.$set(_vm.query, "orderNo", $$v)
                    },
                    expression: "query.orderNo",
                  },
                }),
              ],
              1
            ),
            _c(
              "el-form-item",
              { attrs: { label: "日期" } },
              [
                _c("el-date-picker", {
                  staticStyle: { width: "100%" },
                  attrs: {
                    type: "datetimerange",
                    "range-separator": "至",
                    "start-placeholder": "开始日期",
                    "value-format": "yyyy-MM-dd HH:mm:ss",
                    "end-placeholder": "结束日期",
                  },
                  model: {
                    value: _vm.dateArray,
                    callback: function ($$v) {
                      _vm.dateArray = $$v
                    },
                    expression: "dateArray",
                  },
                }),
              ],
              1
            ),
            _c(
              "el-form-item",
              { attrs: { label: "站点", prop: "stationId" } },
              [
                _c("yd-common-selector", {
                  attrs: {
                    placeholder: "请输入关键字查找线路名称",
                    options: _vm.stationNameList,
                  },
                  model: {
                    value: _vm.query.stationId,
                    callback: function ($$v) {
                      _vm.$set(_vm.query, "stationId", $$v)
                    },
                    expression: "query.stationId",
                  },
                }),
              ],
              1
            ),
            _c(
              "el-form-item",
              [
                _c(
                  "el-button",
                  {
                    attrs: {
                      type: "primary",
                      icon: "el-icon-search",
                      loading: _vm.loading,
                    },
                    on: { click: _vm.searchChange },
                  },
                  [_vm._v("\n          筛选\n        ")]
                ),
                _c(
                  "el-button",
                  {
                    attrs: {
                      type: "danger",
                      icon: "el-icon-delete",
                      loading: _vm.loading,
                    },
                    on: { click: _vm.searchReset },
                  },
                  [_vm._v("\n          清空\n        ")]
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
    _c(
      "div",
      [
        _c(
          "yd-table",
          {
            attrs: {
              data: _vm.orderData,
              loading: _vm.loading,
              pagination: _vm.pagination,
            },
            on: { onChange: _vm.onTableChange },
          },
          [
            _c("el-table-column", {
              attrs: {
                label: "订单编号",
                prop: "orderId",
                align: "center",
                width: "300",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c(
                        "el-tooltip",
                        {
                          attrs: {
                            placement: "right",
                            effect: "dark",
                            trigger: "hover",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "content",
                                fn: function () {
                                  return [
                                    _c(
                                      "span",
                                      {
                                        staticStyle: { cursor: "pointer" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.copyOrderNo(
                                              scope.row.orderNo
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("复制")]
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            true
                          ),
                        },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "text" },
                              on: {
                                click: function ($event) {
                                  return _vm.openMap(scope.row)
                                },
                              },
                            },
                            [_vm._v(_vm._s(scope.row.orderNo))]
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                label: "订单类型",
                prop: "type",
                align: "center",
                width: "100",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm._v(
                        "\n          " +
                          _vm._s(scope.row.type ? scope.row.type : "接单") +
                          "\n        "
                      ),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                label: "订单距离（公里）",
                prop: "distance",
                align: "center",
                width: "170",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm._v(
                        "\n          " +
                          _vm._s(scope.row.distance || "-") +
                          "\n        "
                      ),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                label: "订单价格",
                prop: "price",
                align: "center",
                width: "120",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm._v(
                        "\n          " +
                          _vm._s(scope.row.price / 100) +
                          "\n        "
                      ),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                label: "订单出发时间",
                prop: "tripTime",
                align: "center",
                width: "170",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm._v(
                        "\n          " +
                          _vm._s(scope.row.tripTime || "-") +
                          "\n        "
                      ),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                label: "订单派单时间",
                prop: "beginTime",
                align: "center",
                width: "170",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm._v(
                        "\n          " +
                          _vm._s(scope.row.beginTime || "-") +
                          "\n        "
                      ),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                label: "是否派单成功",
                prop: "scheduleSuc",
                align: "center",
                width: "120",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm._v(
                        "\n          " +
                          _vm._s(scope.row.scheduleSuc === 1 ? "是" : "否") +
                          "\n        "
                      ),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                label: "派单成功时间",
                prop: "sucTime",
                align: "center",
                width: "170",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm._v(
                        "\n          " +
                          _vm._s(scope.row.sucTime || "-") +
                          "\n        "
                      ),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                label: "派单次数",
                prop: "num",
                align: "center",
                width: "100",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm._v(
                        "\n          " +
                          _vm._s(scope.row.num || "-") +
                          "\n        "
                      ),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                label: "接单司机",
                prop: "driverPhone",
                align: "center",
                width: "120",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm._v(
                        "\n          " +
                          _vm._s(scope.row.driverPhone || "-") +
                          "\n        "
                      ),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                label: "是否拼单",
                prop: "mergeType",
                align: "center",
                width: "100",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            scope.row.mergeType && scope.row.mergeType === 1
                              ? "是"
                              : "否"
                          ) +
                          "\n        "
                      ),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
      ],
      1
    ),
    _vm.visible
      ? _c(
          "div",
          [
            _c(
              "el-dialog",
              {
                attrs: {
                  title: "位置信息",
                  visible: _vm.visible,
                  width: "1200px",
                },
                on: {
                  "update:visible": function ($event) {
                    _vm.visible = $event
                  },
                },
              },
              [
                _c("MapInfo", {
                  attrs: { data: _vm.mapData, centerPoint: _vm.centerPoint },
                }),
              ],
              1
            ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }